import { render, staticRenderFns } from "./lang_swich.vue?vue&type=template&id=819bf0f2&scoped=true&"
import script from "./lang_swich.vue?vue&type=script&lang=js&"
export * from "./lang_swich.vue?vue&type=script&lang=js&"
import style0 from "./lang_swich.vue?vue&type=style&index=0&id=819bf0f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819bf0f2",
  null
  
)

export default component.exports